export default __webpack_public_path__ + "9497d718664ead6c0cd20f43e3f81f09.webp";